import type { TranslateFn } from "../../i18n";
import type { ViewState } from "../types";
import { RulerIcon, CameraIcon, SparkleIcon, ArrowRightIcon } from "../icons";

export function WelcomeView({
  productImage, setView, t,
}: {
  productImage: string;
  setView: (v: ViewState) => void;
  t: TranslateFn;
}) {
  return (
    <div className="ps-tryon-welcome">
      <div className="ps-tryon-welcome-hero">
        {productImage && (
          <div className="ps-tryon-welcome-img-wrap">
            <img src={productImage} alt={t("Product")} className="ps-tryon-welcome-product" />
            <div className="ps-tryon-welcome-sparkle"><SparkleIcon size={20} /></div>
          </div>
        )}
        <h2 className="ps-tryon-welcome-title">{t("See Your Fit")}</h2>
        <p className="ps-tryon-welcome-sub">{t("Check your size, then try it on virtually")}</p>
      </div>
      <div className="ps-tryon-features">
        {[
          { icon: <RulerIcon size={22} />, title: t("Get Your Size"), desc: t("Instant fit suggestion") },
          { icon: <CameraIcon size={22} />, title: t("Try It On"), desc: t("See how it looks on you") },
        ].map((f, i) => (
          <div key={i} className="ps-tryon-feature">
            <div className="ps-tryon-feature-icon">{f.icon}</div>
            <div className="ps-tryon-feature-title">{f.title}</div>
            <div className="ps-tryon-feature-desc">{f.desc}</div>
          </div>
        ))}
      </div>
      <button className="ps-tryon-cta" onClick={() => setView("body-profile")}>
        {t("See Your Fit")} <ArrowRightIcon />
      </button>
      <div className="ps-tryon-welcome-note">{t("Takes less than a minute")}</div>
    </div>
  );
}
